import { useEffect, useState, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Autocomplete,
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import { makeStyles } from "@mui/styles";
import { PropTypes } from "prop-types";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import RouteConstants from "../../common/RouteConstants";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import { AppDataContext } from "../../common/appContext";
import { baseUrl } from "../../services";

import BasicStatRow from "./BasicStatRow";

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "15vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-moz-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-o-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-ms-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "linear-gradient(to bottom, #1d428a 230px, #f6f6f6 21px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  backButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  playerName: {
    color: "#fff",
    padding: "2px",
    fontWeight: "bold",
  },
  basicStat: {
    marginTop: "10px",
  },
  userLabel: {
    paddingLeft: "10px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function ComapereStats() {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, eventId } = useContext(AppDataContext);
  const [playersList, setPlayersList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [mainPlayer, setMainPlayer] = useState({});
  const [selectedPlayers, setSelectedPlayers] = useState([]);

  useEffect(() => {
    let mainPlayerId = searchParams.get("playerId");
    PlayerProfileService.getPlayerListByEventIdYear(
      eventId,
      user?.loginID
    ).then((response) => {
      setPlayersList(response.data);
      let player = response.data.filter((p) => p.playerID == mainPlayerId);
      if (player && player.length > 0) {
        setMainPlayer(player[0]);
      }
    });
  }, []);

  const handleSelectedPlayers = (val) => {
    setSelectedPlayers(val);
    //let currentUsersList = [...selectedUsers];
    //let index = currentUsersList.findIndex((x) => x.officialUID === item.officialUID);
  };

  //console.log("playersList", playersList);

  //   const handleChange = (event, newValue) => {
  //     setSelectedTab(newValue);
  //   };

  //   const handleChangeIndex = (index) => {
  //     setSelectedTab(index);
  //   };

  return (
    <>
      <Box className={classes.bgBlue}>
        <AppBar position="static" className={classes.appbarBackground}>
          <Toolbar variant="dense">
            <Typography noWrap align="left" className={classes.title}>
              Compare Player Stats | {mainPlayer.playerName}
              {/* <span style={{ color: "#c8102e" }}> {playerData.playerName}</span> */}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                columnGap: "10px",
              }}
            >
              <Button
                size="small"
                variant="outlined"
                className={classes.backButton}
                startIcon={<ReplyIcon />}
                onClick={() => navigate(RouteConstants.PLAYER_LIST)}
              >
                Back
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
        <Container maxWidth={false}>
          <Box
            pt={2}
            pb={2}
            sx={{ display: "grid", gridTemplateColumns: "200px auto" }}
            columnGap={2}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: "#d3d3d3",
                    width: 50,
                    height: 50,
                  }}
                  src={
                    mainPlayer.headshotURL
                      ? baseUrl(mainPlayer.headshotURL)
                      : ""
                  }
                  alt="basketball"
                ></Avatar>{" "}
                <div className={classes.playerName}>
                  {mainPlayer.playerName}
                </div>
              </Box>
            </Box>
            <Box>
              <Grid container></Grid>
            </Box>
          </Box>
          <Box>
            <Autocomplete
              value={!!selectedPlayers ? selectedPlayers : []}
              multiple
              limitTags={2}
              id="tags-outlined"
              size="small"
              fullWidth={true}
              options={playersList}
              disableCloseOnSelect
              getOptionLabel={(option) => option.playerName}
              onChange={(event, newValue) => {
                handleSelectedPlayers(newValue);
              }}
              //renderTags={(value, getTagProps) =>
              //    value.map((option, index) => (
              //      <Chip variant="outlined" label={option} {...getTagProps({ index })} />
              //    ))
              //  }
              renderOption={(option) => (
                <>
                  <span className={classes.userLabel}>{option.playerName}</span>
                </>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Players"
                  placeholder="Select Players"
                  size="small"
                />
              )}
            />
          </Box>
        </Container>
      </Box>
      <div className={classes.basicStat}>
        <BasicStatRow />
      </div>
    </>
  );
}
